import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { TeamCard } from "entitites/teams/ui";
import React from "react";
import { TeamPageHeaderGrid } from "./TeamPageHeaderGrid";
import AutoSizer from "react-virtualized-auto-sizer";
import { useParams } from "react-router-dom";
import { useGetTeamByIdQuery } from "entitites/teams/api/teamsApi";
import LinearProgress from "@mui/material/LinearProgress";

export const TeamGrid = () => {
  const { id } = useParams();
  const {
    data: team,
    isLoading,
    isUninitialized,
  } = useGetTeamByIdQuery(`${id}`);

  return (
    <Box pt={2.5} height="100%" display="flex" flexDirection="column">
      <TeamPageHeaderGrid
        teamId={team?.id || ""}
        teamName={team?.name || ""}
        teamLeadId={team?.teamLeadId || ""}
        teamLeadName={team?.teamLead.fio || ""}
      />
      {isLoading || isUninitialized ? (
        <LinearProgress sx={{ mt: -0.25, ml: -0.25 }} />
      ) : (
        <Box bgcolor="white" height="100%">
          <AutoSizer>
            {({ height, width }: { width: number; height: number }) => (
              <Grid
                p="15px"
                maxHeight={height}
                width={width}
                container
                rowGap={1}
                columnGap={1}
                overflow="auto"
              >
                {team?.users.map((user: any) => (
                  <Grid minHeight="100%" key={user.id} item>
                    <TeamCard teamId={team?.id} user={user} />
                  </Grid>
                ))}
              </Grid>
            )}
          </AutoSizer>
        </Box>
      )}
    </Box>
  );
};
